import React from "react";

import s from "./Description.module.scss";

const DescriptionAudiocall = () => {
  return (
    <div className={s.description}>
      <h2>Аудиовызов</h2>
      <p>
        Хорошои ли вы распазнаете английские слова на слух ? Испытайте себя! Проверьте свои знания, а также
        закрепите успехи в игре Аудиовызов. Вы услышите слово на английском языке и вам нужно будет выбрать верный вариант 
        перевода данного слова на русский язык из пяти предложенных вариантов. После выбора вам будет показан верный 
        вариант ответа, а именно перевод слова на русский и его картинка.
        
      </p>
    </div>
  );
};

export default DescriptionAudiocall;
